import "core-js/modules/es.array.sort.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.sort.js";
import React, { useState, useEffect } from 'react';
import { useStaticQuery } from 'gatsby';
import Helmet from 'react-helmet';
import '@fortawesome/fontawesome-pro/css/all.css';
import Navbar from '@accrosoft-ltd/vf-careers-site-theme/src/components/Navbar'; // const base64url = require('base64url');

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Header = function Header(props) {
  // const params = new URLSearchParams(props.location.search);
  // const extraDataEncoded = params ? params.get('ExtraData') : null;
  // const extraDataDecoded = extraDataEncoded
  //   ? base64url.decode(extraDataEncoded)
  //   : null;
  // const extraDataDecodedSplit = extraDataDecoded
  //   ? extraDataDecoded.split('|')
  //   : [];
  var _useState = useState(true),
      websiteNavLoading = _useState[0],
      setWebsiteNavLoading = _useState[1];

  var _useState2 = useState([]),
      websiteNavData = _useState2[0],
      setWebsiteNavData = _useState2[1];

  function shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);
    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);
    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;
    var RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16);
    return '#' + RR + GG + BB;
  }

  var accropressWebsiteNavigation = useStaticQuery("2344792239");

  var returnSortedNavigation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(websiteNavJSON, fromGQL) {
      var dynamicSort, procesItem, processArray, websiteNavItems, _websiteNavItems;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!websiteNavLoading) {
                _context3.next = 17;
                break;
              } // function GetSortOrder(prop) {
              //   return function (a, b) {
              //     if (a[prop] > b[prop]) {
              //       return 1;
              //     } else if (a[prop] < b[prop]) {
              //       return -1;
              //     }
              //     return 0;
              //   };
              // }


              dynamicSort = function dynamicSort(property) {
                var sortOrder = 1;

                if (property[0] === '-') {
                  sortOrder = -1;
                  property = property.substr(1);
                }

                return function (a, b) {
                  /* next line works with strings and numbers,
                   * and you may want to customize it to your needs
                   */
                  var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                  return result * sortOrder;
                };
              };

              procesItem = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, newArrayOrder) {
                  var newChildrenOrder;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!item.children) {
                            _context.next = 8;
                            break;
                          }

                          _context.next = 3;
                          return item.children.sort(dynamicSort('order'));

                        case 3:
                          newChildrenOrder = _context.sent;
                          item.children = newChildrenOrder;
                          newArrayOrder.push(item);
                          _context.next = 9;
                          break;

                        case 8:
                          newArrayOrder.push(item);

                        case 9:
                          return _context.abrupt("return", item);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function procesItem(_x3, _x4) {
                  return _ref2.apply(this, arguments);
                };
              }();

              processArray = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(array) {
                  var newArrayOrder, _iterator, _step, item;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          newArrayOrder = [];
                          _iterator = _createForOfIteratorHelperLoose(array);

                        case 2:
                          if ((_step = _iterator()).done) {
                            _context2.next = 8;
                            break;
                          }

                          item = _step.value;
                          _context2.next = 6;
                          return procesItem(item, newArrayOrder);

                        case 6:
                          _context2.next = 2;
                          break;

                        case 8:
                          _context2.next = 10;
                          return newArrayOrder.sort(dynamicSort('order'));

                        case 10:
                          newArrayOrder = _context2.sent;
                          return _context2.abrupt("return", newArrayOrder);

                        case 12:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function processArray(_x5) {
                  return _ref3.apply(this, arguments);
                };
              }();

              if (!fromGQL) {
                _context3.next = 12;
                break;
              }

              _context3.next = 7;
              return processArray(websiteNavJSON.allAccroPress.nodes[0].menu);

            case 7:
              websiteNavItems = _context3.sent;

              if (websiteNavItems) {
                setWebsiteNavData(websiteNavItems);
              } else {
                setWebsiteNavData(websiteNavJSON.allAccroPress.nodes[0].menu);
              }

              setWebsiteNavLoading(false);
              _context3.next = 17;
              break;

            case 12:
              _context3.next = 14;
              return processArray(websiteNavJSON.menu);

            case 14:
              _websiteNavItems = _context3.sent;

              if (_websiteNavItems) {
                setWebsiteNavData(_websiteNavItems);
              } else {
                setWebsiteNavData(websiteNavJSON.menu);
              }

              setWebsiteNavLoading(false);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function returnSortedNavigation(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (props.siteConfig.showWebsiteNav) {
      returnSortedNavigation(props.navResultData || accropressWebsiteNavigation, props.navResultData ? false : true);
    }
  }, [websiteNavLoading, accropressWebsiteNavigation, props.siteConfig.showWebsiteNav, props.navResultData, returnSortedNavigation]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.smartfeedCompanyData && props.smartfeedCompanyData.CompanyName && props.smartfeedCompanyData.CompanyName !== 'DefaultCompany' && /*#__PURE__*/_jsx("div", {
      className: "top-header-area",
      children: /*#__PURE__*/_jsx("header", {
        id: "header",
        className: "header",
        children: props && !props.vacanciesRouteLoading && !props.vacanciesRouteError && props.apiKey && /*#__PURE__*/_jsxs(_Fragment, {
          children: [props.smartfeedCompanyData && props.smartfeedCompanyData.FullTheme && /*#__PURE__*/_jsxs(Helmet, {
            style: [{
              cssText: ".page-background-colour {\n                          background-colour: " + (props.smartfeedCompanyData.FullTheme.BackgroundColour || 'TRANSPARENT') + ";\n                        }\n                        .content-background-colour {\n                          background-colour: " + (props.smartfeedCompanyData.FullTheme.ContentBackColour || 'TRANSPARENT') + ";\n                        }\n                        .content-foreground-colour {\n                          color: " + (props.smartfeedCompanyData.FullTheme.ContentForeColour || '#000000') + ";\n                        }\n                        body {\n                          font-size: " + (props.smartfeedCompanyData.FullTheme.DefaultFontSize || '16px') + ";\n                          font-family: " + (props.smartfeedCompanyData.FullTheme.FontFamily || "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'") + "\n                        }\n                        .link-colour, a, .header .top-links__wrapper .header__top-links li a, .top-links__wrapper__container .dropdown-wrapper-nav .dropdown-parentLink.link-item {\n                          color: " + (props.smartfeedCompanyData.FullTheme.LinkColour || '#337ab7') + "\n                        }\n                        .job-card-title, .job-card-title a, section .vacancies-landing__header__heading, .ctacard.ctacard-application .ctacard__body__title {\n                          color: " + (props.smartfeedCompanyData.Theme.PrimaryButtonColour || 'rgb(21, 40, 92)') + ";\n                        }\n                        .job-card-savejob span, .screen-reader {\n                          color: " + (shadeColor(props.smartfeedCompanyData.Theme.PrimaryButtonColour, 20) || shadeColor('rgb(21, 40, 92)', 20)) + "\n                        }\n                        .job-card-meta .job-card-meta-item span {\n                          color: " + (shadeColor(props.smartfeedCompanyData.Theme.PrimaryButtonColour, 20) || shadeColor('rgb(21, 40, 92)', 20)) + ";\n                        }\n                        .btn--primary, .nav-action-sm, .btn--action, .vf-careers-site-spacing .btn--action {\n                          background: " + (props.smartfeedCompanyData.Theme.PrimaryButtonColour || 'rgb(21, 40, 92)') + ";\n                          border: " + ('3px solid ' + props.smartfeedCompanyData.Theme.PrimaryButtonColour || '#ffcb05') + ";\n                          color: " + (props.smartfeedCompanyData.Theme.PrimaryButtonTextColour || '#FFFFFF') + "\n                        }\n                        .btn--primary:hover, .nav-action-sm:hover, .btn--action:hover, .vf-careers-site-spacing .btn--action:hover {\n                          background: " + (props.smartfeedCompanyData.FullTheme.PrimaryButtonBackgroundHoverColour || '#324370') + " !important;\n                          color: " + (props.smartfeedCompanyData.FullTheme.PrimaryButtonTextHoverColour || '#FFFFFF') + " !important;\n                        }\n                        .btn--secondary, .vf-details ul.vf-Attachments li a.btn-filedownload {\n                          background: " + (props.smartfeedCompanyData.FullTheme.SecondaryButtonBackgroundColour || 'transparent') + ";\n                          color: " + (props.smartfeedCompanyData.FullTheme.SecondaryButtonTextColour || '#337ab7') + ";\n                          border: 1px solid " + (props.smartfeedCompanyData.FullTheme.SecondaryButtonBackgroundColour || '#337ab7') + "\n                        }\n                        .btn--secondary:hover {\n                          background: " + (props.smartfeedCompanyData.FullTheme.SecondaryButtonBackgroundHoverColour || '#324370') + ";\n                          color: " + (props.smartfeedCompanyData.FullTheme.SecondaryButtonTextHoverColour || '#FFFFFF') + ";\n                          border: 1px solid " + (props.smartfeedCompanyData.FullTheme.SecondaryButtonBackgroundHoverColour || '#324370') + ";\n                        }\n                        .table-header-wrapper, #listing-top-single-loading {\n                          background: " + (props.smartfeedCompanyData.FullTheme.TableHeaderColour || '#15285c') + ";\n                          color: " + (props.smartfeedCompanyData.FullTheme.TableHeaderTextColour || '#ffffff') + "\n                        }\n                        .footer-register-wrap a.btn--action {\n                            background: " + (shadeColor(props.smartfeedCompanyData.Theme.PrimaryButtonColour, 20) || shadeColor('rgb(21, 40, 92)', 20)) + "\n                        }\n                        "
            }],
            children: [/*#__PURE__*/_jsx("link", {
              rel: "icon",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico'
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "16x16"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "48x48"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "72*72"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "96*96"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "144x144"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "192*192"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "256*256"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "384*384"
            }), /*#__PURE__*/_jsx("link", {
              rel: "icon",
              type: "image/png",
              href: props.smartfeedCompanyData.FullTheme.FavIconUrl || 'favicon.ico',
              sizes: "512*512"
            })]
          }), /*#__PURE__*/_jsx(Navbar, {
            props: props,
            websiteNavData: websiteNavData
          })]
        })
      })
    })
  });
};

export default Header;